import PolylineUtils from 'js/services/util/polyline_utils'
import TopologyCalculationsService from 'js/services/topology-calculations.js'

export default {
  data() {
    return {
      shapesPerRoute: {},
      completeShape: undefined
    }
  },

  watch: {
    routesToShow() {
      this.generateCompleteShape()
    }
  },

  methods: {
    generateCompleteShape() {
      let completeShapeArray = []

      this.routesToShow.forEach(currentRoute => {
        const decodedPoints = PolylineUtils.decodePolyline(currentRoute.encoded_shape)
        const shape = _.map(decodedPoints, decodedPoint => ({
          lat: decodedPoint[0],
          lng: decodedPoint[1]
        }))
        completeShapeArray = completeShapeArray.concat(shape)
      })

      if (completeShapeArray.length) {
        this.completeShape = TopologyCalculationsService.getGeojson(completeShapeArray)
      } else {
        this.completeShape = undefined
      }
    },

    /*
     * Carga los shapes de la ruta
     */
    getAllRouteShapes(routes = []) {
      routes.forEach(currentRoute => {
        const decodedPoints = PolylineUtils.decodePolyline(currentRoute.encoded_shape)
        const shape = _.map(decodedPoints, decodedPoint => ({
          lat: decodedPoint[0],
          lng: decodedPoint[1]
        }))
        const geojson = TopologyCalculationsService.getGeojson(shape)

        if (geojson) {
          const polyline = TopologyCalculationsService.coordsToLatLngs(geojson)
          const routeIndex = _.findIndex(routes, route => route.id === currentRoute.id)

          this.$set(this.shapesPerRoute, currentRoute.id, geojson)
          this.$set(routes, routeIndex, _.merge(routes[routeIndex], {polyline}))
        }
      })
    },

    completeShapeStyle() {
      return {
        color: '#ffffff',
        opacity: 0,
        weight: 3
      }
    }
  }
}
